import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IModel } from "../legalTaskType";
import { safeFormatDate } from "../../models/DateFormatMapper";
interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
}

export const EmptyTaskType = {
  task_Id: undefined,
  task_Type: "",
};

export const Table = (props: IProps) => {
  const [taskList, setTaskList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

   const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj.date_Format;
 
  const loadTasks = async () => {
    try {
      setLoading(true);

      const response = await Fetch("Legal_Task/taskDropdown", "GET", null, null, props.toast);

      if (response?.ok) {
        const data = await response.json();
        setTaskList(data || []);
      } else {
        setTaskList([]);
      }
    } catch (error) {
      console.error(error);
      setTaskList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTasks();
  }, [props.reload]);

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };
  const openNew = () => {
    props.setModal({
      open: true,
      singleData: EmptyTaskType,
    });
  };

  return (
    <>
      <Toolbar left={leftToolbarTemplate} className="mb-3" />

      <DataTable value={taskList} loading={loading} showGridlines stripedRows header="Task Types">
        <Column header="SN" body={(_, options) => options.rowIndex + 1} />
        <Column field="task_Name" header="Task Name" />
        <Column field="created_By" header="Created By" />
        <Column field="created_At" header="Created At" body={(rowData: any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat, true)} />
      </DataTable>
    </>
  );
};
